// Module
var code = "<page-about></page-about> <page-projects></page-projects> <page-contact></page-contact>";
// Exports
export default code;